<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>

<form
  name="financialAdjustmentsForm"
  [formGroup]="financialAdjustmentsForm"
  *ngIf="hasEntitlement('CARDHOLDERS_ADJUSTMENTS_FINANCIAL_ADJUSTMENTS')"
>
  <div id="bulkCardsDetails" class="card card-nc">
    <div class="card-heading ">
      <i class="fa fa-credit-card"></i>
      <span class="cardHeaderHeading"> FINANCIAL ADJUSTMENTS </span>
      <span class="float-right save-card">
        <app-confirm-button-combo
          [baseLabel]="' TRANSFER '"
          (confirmSelected)="applyAdjustment()"
          [commit_btn_spinner]="applyBalanceButtonSpinnerString"
          (baseButtonClicked)="adjustmentTransferClicked()"
          [formGroup]="financialAdjustmentsForm"
        >
        </app-confirm-button-combo>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label
            for="adjustReason"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Adjustment Reason
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              id="adjustReason"
              name="adjustReason"
              formControlName="adjustReason"
              required
            >
              <option
                *ngFor="let adjustReason of adjustmentReasons"
                [value]="adjustReason.COLUMN_VALUE"
              >
                {{ adjustReason.DESCR }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <label
            for="adjustAmt"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Adjustment Amount
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="adjustAmt"
              name="adjustAmt"
              formControlName="adjustAmt"
              placeholder="0.00"
              maxlength="11"
              required
              [ngClass]="{
                'has-error':
                  finAdjFormHandle?.adjustAmt?.invalid &&
                  finAdjFormHandle?.adjustAmt?.touched
              }"
            /><span
            class="help-block has-error validationMessage"
            *ngIf="
                !finAdjFormHandle.adjustAmt.valid &&
                finAdjFormHandle.adjustAmt.touched
              "
          >
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.pattern">
                Amount is not valid
              </span>
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.required">
                Required
              </span>
              <span *ngIf="finAdjFormHandle.adjustAmt.errors?.maxlength">
                Amount can only be 11 characters
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<form
  name="merchantCardLimitsForm"
  [formGroup]="merchantCardLimitsForm"
  *ngIf="hasEntitlement('CARDHOLDERS_ADJUSTMENTS_FINANCIAL_ADJUSTMENTS')"
>
  <div id="merchantCardLimits" class="card card-nc">
    <div class="card-heading ">
      <i class="fa fa-credit-card"></i>
      <span class="cardHeaderHeading"> MERCHANT CARD LIMIT - </span>
      <span class="cardHeaderVal">{{ stripAccount }}</span>
      <span class="float-right save-card">
        <app-confirm-button-combo
          [baseLabel]="' UPDATE '"
          (confirmSelected)="updateCardLimit()"
          [commit_btn_spinner]="updateLimitButtonSpinnerString"
          (baseButtonClicked)="cardLimitUpdateClicked()"
          [formGroup]="merchantCardLimitsForm"
        >
        </app-confirm-button-combo>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label
            for="cardLimit"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Card Limit Amount
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="cardLimit"
              name="cardLimit"
              formControlName="cardLimit"
              placeholder="0.00"
              maxlength="11"
              required
              (focus)="$any($event.target).select()"
              [ngClass]="{
                'has-error':
                  cardLimitFormHandle?.cardLimit?.invalid &&
                  cardLimitFormHandle?.cardLimit?.touched
              }"
            /><span
            class="help-block has-error validationMessage"
            *ngIf="
                !cardLimitFormHandle.cardLimit.valid &&
                cardLimitFormHandle.cardLimit.touched
              "
          >
              <span *ngIf="cardLimitFormHandle.cardLimit.errors?.pattern">
                Amount is not valid
              </span>
              <span *ngIf="cardLimitFormHandle.cardLimit.errors?.required">
                Required
              </span>
              <span *ngIf="cardLimitFormHandle.cardLimit.errors?.maxlength">
                Amount can only be 11 characters
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<form
  name="balanceTransferForm"
  [formGroup]="balanceTransferForm"
  *ngIf="hasEntitlement('CARDHOLDERS_ADJUSTMENTS_BALANCE_TRANSFER')"
>
  <div class="card card-nc">
    <div class="card-heading ">
      <i class="fa fa-exchange"></i>
      <span class="cardHeaderHeading"> BALANCE TRANSFER </span>
      <span class="float-right save-card">
        <app-confirm-button-combo
          [baseLabel]="' TRANSFER '"
          (confirmSelected)="balanceTransfer()"
          [commit_btn_spinner]="applyBalanceButtonSpinnerString"
          (baseButtonClicked)="balanceTransferClicked()"
          [formGroup]="balanceTransferForm"
        >
        </app-confirm-button-combo>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label
            for="srcAcct"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Source Account Number
          </label>
          <div class="form-group col-md-12">
            <select
              class="form-control input-sm"
              id="srcAcct"
              name="srcAcct"
              formControlName="srcAcct"
            >
              <option
                *ngFor="let srcAcct of srcAccts"
                [value]="srcAcct.account"
              >
                {{ srcAcct.account + ' - ' + srcAcct.type }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <label
            for="desAcct"
            class="col-md-12 control-label labelCommon text-nowrap"
          >
            Destination Account Number
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="desAcct"
              formControlName="desAcct"
              name="desAcct"
              maxlength="16"
              required
              [ngClass]="{
                'has-error':
                  balTransFormHandle.desAcct.invalid &&
                  balTransFormHandle.desAcct.touched
              }"
            /><span
            class="help-block has-error validationMessage"
            *ngIf="
                !balTransFormHandle.desAcct.valid &&
                balTransFormHandle.desAcct.touched
              "
          >
              <span *ngIf="balTransFormHandle.desAcct.errors?.pattern">
                Number is not valid
              </span>
              <span *ngIf="balTransFormHandle.desAcct.errors?.required">
                Required
              </span>
              <span *ngIf="balTransFormHandle.desAcct.errors?.maxlength">
                Number can only be 16 characters
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <label for="xferAmt" class="col-md-12 control-label labelCommon">
            Transfer Amount
          </label>
          <div class="form-group col-md-12">
            <input
              type="text"
              class="form-control input-sm"
              id="xferAmt"
              formControlName="xferAmt"
              name="xferAmt"
              placeholder="0.00"
              maxlength="10"
              required
              [ngClass]="{
                'has-error':
                  balTransFormHandle.xferAmt.invalid &&
                  balTransFormHandle.xferAmt.touched
              }"
            /><span
            class="help-block has-error validationMessage"
            *ngIf="
                !balTransFormHandle.xferAmt.valid &&
                balTransFormHandle.xferAmt.touched
              "
          >
              <span *ngIf="balTransFormHandle.xferAmt.errors?.pattern">
                Number is not valid
              </span>
              <span *ngIf="balTransFormHandle.xferAmt.errors?.required">
                Required
              </span>
              <span *ngIf="balTransFormHandle.xferAmt.errors?.maxlength">
                Transfer amount can only be 10 characters
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div
  class="whiteCardRow labelBlueBold"
  *ngIf="transferSummary"
  document-click="clearActionTips($event)"
>
  BALANCE TRANSFER DETAILS
  <div class="row">
    <label class="col-md-4">&nbsp;</label>
    <label class="col-md-4 control-label labelBlueBold"> Source </label>
    <label class="col-md-4 control-label labelBlueBold"> Destination </label>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon">Client Account Number</label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcClntAcct }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desClntAcct }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Account Number </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcAcct }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desAcct }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Account Holder Name </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcName }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desName }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> SSN </label>
    <div class="col-md-4 staticText3">{{ transferSummary.srcSsn4 }}</div>
    <div class="col-md-4 staticText3">{{ transferSummary.desSsn4 }}</div>
  </div>
  <div class="row borderLine">
    <label class="col-md-4 labelCommon"> Amount Transferred </label>
    <div class="col-md-8 staticText3">
      {{ transferSummary.amount | currency }}
    </div>
  </div>
  <div class="row">
    <label class="col-md-4 labelCommon"> Current Balance </label>
    <div class="col-md-4 staticText3">
      {{ transferSummary.srcBal | currency }}
    </div>
    <div class="col-md-4 staticText3">
      {{ transferSummary.desBal | currency }}
    </div>
  </div>
</div>
